module.exports = __webpack_public_path__ + "static/media/institute-29-min.23b105ef.webp";